// The urgency filter, shared by the work board and the leads pipeline so the two
// screens filter identically. `value` is null for "everything"; clicking the active
// level clears it, same as the stage chips on the pipeline rail.
import he from '../i18n/he';
import Button from './Button';
import { URGENCY_ORDER } from './UrgencyBadge';

export default function UrgencyFilter({ value, onChange }) {
  return (
    <div className="filter-bar">
      <span className="muted small-note">{he.urgencyLabel}</span>
      <div className="seg">
        <Button small variant={value ? 'subtle' : ''} onClick={() => onChange(null)}>
          {he.urgencyFilterAll}
        </Button>
        {URGENCY_ORDER.map((u) => (
          <Button
            key={u}
            small
            variant={value === u ? '' : 'subtle'}
            onClick={() => onChange(value === u ? null : u)}
          >
            {he.taskUrgency[u]}
          </Button>
        ))}
      </div>
    </div>
  );
}
